import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes, last-wins on conflicts.
 *
 * `clsx` handles the conditionals; `twMerge` resolves the conflicts clsx cannot
 * see - without it `cn('p-2', 'p-4')` emits both and the winner depends on
 * stylesheet order rather than call order.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
